export default __webpack_public_path__ + "static/media/EllipsisIcon.6247c091.svg";